import axios from "axios";

export const getAllOrdersBetweenDates = (startDate, endDate) => {
    return axios
            .get( "https://fire-hose-complete-backend.onrender.com/fire-hose-management/orders", {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                },
            } )
        .then((response) => {
            return response.data;
        });
};
